<template>
  <div>
    <div id="qrcode" ref="qrcode"></div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "QrCode",
  props: ["msg"],
  components: {},
  data() {
    return {};
  },
  mounted() {

      this.qrcode();
      
  },
  watch: {
    msg(){
      document.getElementById("qrcode").innerHTML = "";
      this.qrcode();
    },
  },
  methods: {
    // 生成分享二维码
    qrcode() {

        let qrcode = new QRCode("qrcode", {
          width: 232, // 设置宽度
          height: 232, // 设置高度
          text: this.msg
        });
      
    },
  }
};
</script>

<style>
</style>